import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import Layout from './Layout';

/** Deja pasar solo a un afiliado activo con su ficha cargada; si no, al login. */
export default function RequireAuth() {
  const { loading, session, ficha } = useAuth();
  if (loading) {
    return (
      <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }} role="status" aria-label="Cargando">
        <CircularProgress />
      </Box>
    );
  }
  if (!session || !ficha) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
